import { useEffect } from "react";

const SITE_URL = "https://sunpresssolar.com";
const SITE_NAME = "SunPress Solar";
const DEFAULT_TITLE = "SunPress Solar — Low-Watt Appliances for Solar & Inverter Homes";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE_NAME}` : DEFAULT_TITLE;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    let l = document.querySelector('link[rel="canonical"]');
    if (!l) {
      l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      document.head.appendChild(l);
    }
    l.setAttribute("href", SITE_URL + window.location.pathname);
  }, [title, description]);
}

export function useJsonLd(obj) {
  const json = obj ? JSON.stringify(obj) : null;
  useEffect(() => {
    if (!json) return;
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = json;
    document.head.appendChild(s);
    return () => s.remove();
  }, [json]);
}
